import ScrollSnap from './ScrollSnap';
export default ScrollSnap;
